import { Box } from '@mui/material';
import config from '../config';

export function EnvironmentIdentifier(props) {
  const { children, ...rest } = props;

  const identifier = config.isProd ? null : (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        border: '4px solid #629749',
        color: '#629749',
        zIndex: 999999,
        pointerEvents: 'none',
        textAlign: 'center',
        fontFamily: 'monospace',
      }}
    >
      {config.environment}
    </Box>
  );

  return (
    <Box {...rest}>
      {identifier}
      {children}
    </Box>
  );
}
